<template>
  <div>
    <div class="content">
      <p>《“十三五”医疗器械科技创新专项规划》</p>
      <p>
        先进医疗器械是健康保障体系建设的重要基础，是推进医学诊疗技术进步的主要动力，是优化医疗服务供给的核心引擎，也是引领医学模式转变的变革性力量，具有高度的战略性、带动性和成长性，其战略地位受到世界各国的普遍重视，是一个国家科技进步和全民健康保障能力的重要标志。
      </p>
      <p>
        为加速推进医疗器械科技产业发展，更好地满足广大人民群众健康需求，服务我国医疗卫生与健康服务体系建设，促进医疗卫生体制改革的顺利实施，按照《国家创新驱动发展战略纲要》、《国家中长期科学和技术发展规划纲要（2006-2020年）》、《“十三五”国家科技创新规划》、《“健康中国2030”规划纲要》、《中国制造2025》以及《关于促进医药产业健康发展的指导意见》等相关要求，特制定本规划。
      </p>
      <p>一、形势与需求</p>
      <p>（一）战略需求</p>
      <p>
        一是推进健康中国建设，提高全民健康保障能力的战略需求。医疗器械是医疗服务体系、公共卫生体系建设的重要基础，是保障国民健康的战略支撑力量，在健康中国战略中的地位日益凸显。由于创新能力不强，产业基础薄弱，我国医疗设备自主保障水平不高。习近平总书记在全国科技创新大会上强调，“高端医疗设备主要依赖进口，成为看病贵的主要原因之一”。切实提升全民健康水平，推进健康中国建设，必须在医疗器械这一关键驱动领域的科技发展方面实现新的跨越。
      </p>
      <p>
        二是支撑医疗卫生健康体系建设，引领服务模式变革的迫切需求。目前我国医疗卫生服务资源分布严重不均，城乡医疗资源差距较大，边远地区医疗服务覆盖率低，农村、乡镇和社区医疗需求大，健康服务供给严重不足。提升我国医疗器械自主创新能力，加强国产创新医疗装备的应用示范和推广，是建立高效、分级、协同、均质、可及的医疗和健康服务体系，提升医疗卫生服务水平和转变健康服务模式的重要支撑。
      </p>
      <p>
        三是加快医疗器械产业创新升级，提升国产装备全球竞争力的重大需求。近年来，全球医疗器械高科技产业创新活跃、竞争激烈。我国医疗器械产业竞争力不强，高端医疗器械主要依赖进口的局面仍未改变，许多跨国公司通过并购本土优势企业抢占市场。加快推进我国医疗器械科技产业发展，促进医疗器械产业转型升级，是应对主要发达国家全球竞争战略的重大需求。
      </p>
      <p>（二）国内外科技发展态势</p>
      <p>
        一是全球医疗器械领域的创新突破加速演进。现代制造技术、新一代信息技术、现代材料技术、前沿生物技术的革命性进展及其交叉融合，造就了医疗器械领域创新突破加速演进的蓬勃发展局面，颠覆性变革不断涌现。机器人、增材制造（3D打印）、微纳制造等新一代制造技术驱动医疗器械向智能化、自动化、个性化方向发展；大数据、云计算、人工智能等新一代信息技术驱动医疗器械向远程化、移动化、智慧化方向发展；碳纳米管、石墨烯、材料组学等新一代材料和技术驱动生物医用材料向高性能、高生物相容、可诱导分化生长方向发展；组织工程、干细胞、单分子检测、基因编辑等前沿生物技术驱动面向再生医学、基因治疗、分子影像、精确诊断、精准治疗方向的新型医疗器械研发快速发展。
      </p>
      <p>
        二是交叉汇聚、跨界融合发展态势明显。围绕医疗器械创新发展的需求，生物、医学、电子、物理、机械、网络等多学科力量向医疗器械领域汇聚，以医工结合为代表形式的新型创新创业联合体正在形成。“产业、科技、金融”跨界融合，“创新链、产业链、服务链”优化组合，医疗器械领域呈现“融合式、多主体、一体化”发展态势，创新创业高度活跃，新产品、新业态不断涌现。
      </p>
      <p>
        三是医疗器械创新推动健康服务模式加速变革。从全球范围来看，传统的医疗卫生服务模式已不能适应时代需求，以人为本，以健康为中心，成为新一轮医疗器械科技革命的重要方向。在医疗器械领域科技创新的驱动下，医疗服务供给侧改革呈现出越来越强劲的势头，医学服务模式加速由疾病医学服务向健康医学服务模式变革，医疗器械科技发展战略重心逐步从院中诊疗向院前家庭健康管理、院间资源共享以及院后康复的连续性服务方向延伸拓展，面向患者全方位、全生命周期的新型医疗器械创新和技术转化体系构建成为全球医疗科技创新热点，新型的互联网医疗、远程移动医疗、智慧医疗等医疗服务模式呈现蓬勃发展趋势。
      </p>
      <p>（三）科技发展基础</p>
      <p>
        经过多年的发展，尤其是“十二五”以来，我国重点加强了医疗器械领域的科技部署，把医疗器械领域列入我国科技发展的战略重点，制定了《医疗器械科技产业发展专项规划（2011-2015年）》，成立了医疗器械产业技术创新战略联盟，部署了一批创新研究项目，启动实施了“创新医疗器械产品应用示范工程”（“十百千万工程”），大力推动了产学研医协同创新、医疗器械科技金融融合发展，建立健全了医疗器械从技术创新、产品开发、应用评价到示范推广的整套体系。同时，食品药品监管总局加强创新医疗器械评审改革，国家卫生计生委联合工业和信息化部推出国产医疗设备应用示范基地建设，各部门积极推进创新医疗器械的政策优化。
      </p>
      <p>
        “十二五”以来，我国医疗器械领域自主创新的内生动力、创新活力、产业实力显著增强，应用环境、政策环境显著优化，医疗器械国产化发展取得了长足进步。超导磁体、全数字正电子探测器、磁兼容电极、数字化X-射线探测器、单晶超声换能器、CT/X-射线管等核心部件取得实质性突破；X线机、超声、生化等基层新“三大件”实现全线技术升级；MRI、彩超、CT、PET-CT、放疗等高端产品成功国产化；脑起搏器、手术机器人、血管内超声等创新产品取得了重大进展；大型设备检验检测、医疗器械电气安全、电磁兼容等基础技术标准体系不断完善；一批大型国产医疗装备进入国内一流医疗机构，一批数字化、智能化、便携式的创新医疗器械产品在基层得到应用普及。
      </p>
      <p>
        但是，总体来看，我国医疗器械领域的创新整体上仍以跟踪仿制为主，相关科技基础仍需进一步加强，共性关键技术和重要核心部件亟待进一步突破，面向跨学科、跨领域、跨产业的技术融合仍需加强，“产-学-研-医-检”结合还不够紧密，医研企协同创新机制尚待健全，医疗器械科技产业创新模式亟待进一步优化。
      </p>
      <p>二、指导思想与基本原则</p>
      <p>（一）指导思想</p>
      <p>
        围绕医疗卫生体制改革要求以及健康中国建设的重大战略需求，贯彻落实习近平总书记在全国科技创新大会上的讲话精神，以国产化、高端化、品牌化、国际化为方向，以临床及健康需求为导向，以核心技术突破为驱动，以重大产品研发为重点，以示范推广为牵引，创新链、产业链和服务链融合发展，加强医研企结合，着力提高国产医疗器械的核心竞争力，推动医疗器械科技产业的跨越式发展。
      </p>
      <p>（二）基本原则</p>
      <p>
        1.
        加快创新转型。在“十二五”的基础上，更加注重基础研究和原始创新，更加重视带动医学模式变革、支撑健康医学发展的医疗器械发展，加快颠覆性、原创性技术突破，推动医疗器械科技创新从“跟跑”为主向“并跑”、“领跑”发展，掌握全球科技竞争的战略主动。
      </p>
      <p>
        2.
        聚焦重大需求。突出临床急需，优先发展临床需求量大、医疗负担重、主要依赖进口的主流医疗器械产品和面向基层分级诊疗的重点产品；突出健康保障，加快发展个人健康管理等健康促进关键产品。
      </p>
      <p>
        3.
        强化产业支撑。聚焦产业发展需求，加快关键共性技术和核心部件突破，着力解决“卡脖子”的瓶颈问题和影响全局发展的短板问题；着力优化创新医疗器械产品的应用环境，促进普及普惠装备，实现创新驱动和需求拉动的合力发展。
      </p>
      <p>
        4.
        加强品牌培育。加强科学评价与应用示范，制定创新产品目录，加大创新医疗器械产品的普及推广力度，着力培育一批创新型企业和创新品牌，形成品牌化发展的强力导向。
      </p>
      <p>
        5.
        加速产业集聚。改革、营造有利于医疗器械产业发展的政策、金融、监管、学科交叉、医疗示范一体的创新激励、配套政策等产业发展生态环境，打造一批国际一流、链条完善、政策衔接、各具特色的医疗器械产业集群，促进产业集聚发展。
      </p>
      <p>三、发展目标</p>
      <p>（一）总体目标</p>
      <p>
        加速医疗器械产业整体向创新驱动发展的转型，完善医疗器械研发创新链条；突破一批前沿、共性关键技术和核心部件，开发一批进口依赖度高、临床需求迫切的高端、主流医疗器械和适宜基层的智能化、移动化、网络化产品，推出一批基于国产创新医疗器械产品的应用解决方案；培育若干年产值超百亿元的领军企业和一批具备较强创新活力的创新型企业，大幅提高产业竞争力，扩大国产创新医疗器械产品的市场占有率，引领医学模式变革，推进我国医疗器械产业的跨越发展。
      </p>
      <p>（二）具体目标</p>
      <p>
        前沿技术突破。引领国际前沿技术，加快颠覆性技术创新，突破1-3项原始创新技术，10-20项前沿关键技术，形成核心专利300项以上，引领新一代医疗器械产品发展。
      </p>
      <p>
        创新产品研发。主流高端产品全面实现国产化，自主原创产品取得重要突破，研发10-20项前沿创新产品，引领筛查预警、早期诊断、微/无创治疗、个体化诊疗、人工智能诊断、术中精准成像、智慧医疗、中医治未病等新型医疗产品与健康服务技术发展。
      </p>
      <p>
        竞争能力提升。重点培育8-10家在国内、国际市场具备较强竞争力的大型医疗器械企业集团，建立8-10个医疗器械科技产业集聚区，80-100家具有自主核心知识产权且具备一定规模的创新型高技术企业，建立完善的国家医疗器械标准、测试和评价体系，构建我国创新医疗产品示范推广体系，开展万家基层医疗机构的示范应用和装备升级，部分重点产品市场占有率达到30%-40%，整体提升我国医疗器械科技产业的国际竞争力。
      </p>
      <p>四、重点任务</p>
      <p>（一）发展前沿关键技术，引领医疗器械创新</p>
      <p>1. 前沿和颠覆性技术</p>
      <p>
        加强医疗器械的基础前沿研究，发展医疗器械“新理论、新方法、新材料、新工具、新技术”，引领医疗器械领域的重大原创性突破。重点加强新型生物医学成像、新型术中分子影像、生理信号获取、新型测序技术以及医学图像处理、新型体外诊断、组织修复和再生、人工器官、神经工程、健康监测与促进等方面的基础研究。加强精准诊疗、无创检测、医疗人工智能等前沿技术突破及颠覆性创新技术培育，引领新一代诊疗装备发展，推动我国医疗器械科技产业的技术跨越，抢占产业发展制高点。
      </p>
      <p>专栏1：前沿和颠覆性技术重点发展方向</p>
      <p>2. 共性关键技术</p>
      <p>
        加快突破医疗器械产品产业化、工程化及标准化技术，重点发展人机工效、精密制造、可靠性设计与评价、生物学效应评价、医疗器械临床评价等共性技术，积极推进工程物理技术、光学技术、无线通信技术、移动计算技术、物联网技术、先进制造技术等与医疗器械发展和应用密切相关的支撑技术研究。
      </p>
      <p>专栏2：共性关键技术重点发展方向</p>
      <p>
        1.工程化技术。围绕医疗器械研发、制造和应用中存在的产业化与工程化瓶颈问题，开展临床应用评价技术、核心部件失效分析和加速寿命试验及评价技术、面向医疗器械智能制造和系统设计的可靠性建模、仿真、验证和在线检测技术、医疗器械专用集成电路设计与制造等关键技术研究，开发相关的数据库、软件工具和专用装备，并进行推广应用，提升国产产品的性能指标和可靠性。在生产企业推进医疗器械产品智能制造，实现制造过程的精细化与标准化，提升我国医疗器械产品的质量保证能力和规模化生产能力。
      </p>
      <p>
        2.标准化技术。围绕医疗器械产品的技术标准、标准物质与器件、生物学效应评价等基础和共性瓶颈问题，重点开展创新医疗器械的技术标准和评价方法及标准物质研究，提高创新医疗器械质量检测和评价能力，建设符合我国创新医疗器械现状和发展的共性关键技术标准体系，系统完善医疗器械的创新链条。
      </p>
      <p>（二）推进重大产品研发，突破核心部件瓶颈</p>
      <p>
        突出解决我国高端装备、高值耗材大量依赖进口的问题，着力突破高端装备及核心部件国产化的瓶颈问题，实现高端主流装备、关键核心部件及医用高值材料等产品的自主制造，加快新型产品开发，打破进口垄断，降低医疗费用，提高产业竞争力。重点推进五大类重大产品开发，引领科技创新重点向高端产品转移，形成具有市场竞争力的自主品牌。
      </p>
      <p>专栏3：重大产品研发重点发展方向</p>
      <p>1. 医学影像类</p>
      <p>
        新型数字X射线成像系统。重点突破动态平板探测器等核心部件和关键技术，数字X射线机技术水平达到国际先进水平，有效降低整机成本；积极发展探测器新型闪烁晶体制备技术，开发基于光子计数探测器的血管减影造影X射线机，争取在光子计数低剂量成像方面达到国际先进水平。
      </p>
      <p>
        新型超声成像系统。重点开发数字化波束合成、高帧频彩色血流成像、造影剂谐波成像、实时三维成像等高性能彩超，图像细微分辨力、低速细微血流分辨力等技术指标达到国外高端主流产品水平；研发多模态专科超声设备、便携/掌上超声设备；攻克高密度单晶材料换能器关键技术，研发新型超声探头；研发新型弹性成像、超声脑成像等前沿技术和创新产品。
      </p>
      <p>
        计算机断层成像系统（CT）。重点开发具有自主知识产权的256排以上的螺旋CT，空间分辨率及时间分辨率等关键技术指标达到国际同类产品水平，重点突破CT球管、探测器和滑环加工工艺技术、图像处理技术。
      </p>
      <p>
        新型超导磁共振成像系统。重点开发与国外主流产品技术水平相当的高场（不小于3T）超导和专科超导磁共振成像系统，通道数、梯度场强和切换率等技术指标达到同类产品国际先进水平；重点突破零液氦挥发磁体系统、64通道以上全数字化谱仪、高温超导射频线圈、射频放大器、梯度放大器、新型临床应用成像序列等关键部件和核心技术。
      </p>
      <p>
        核医学成像系统。重点开发与国外主流产品技术水平相当的高灵敏度、高分辨力、全数字的PET-CT/MRI、SPECT/SPECT-CT等核医学成像系统整机。重点突破全数字化模块化PET探测器、高配准精度PET-CT同机架、图像处理与算法等关键部件与技术。
      </p>
      <p>
        多模态分子光学影像系统。重点开发非荧光共聚焦显微成像系统、微焦点CT、高灵敏度荧光分子成像系统等分子医学影像前沿产品，突破PET、CT、自体/激发荧光成像、磁共振成像、γ-射线同位素成像等多模态分子影像融合和一体化扫描技术，在多模态成像技术的工程化方面达到国际先进水平。
      </p>
      <p>
        超分辨显微成像系统。重点突破显微成像实时数据处理与图像重建、数字病理分析、快速高灵敏弱光探测等关键技术，攻克大数值孔径物镜、大面阵CMOS探测器、光学重建显微成像信号处理器等核心部件的设计、制造瓶颈，研发超高分辨力病理分析系统、高速结构光照明层切显微镜（SIM）、STORM/SIM融合显微镜、双光子/STED融合显微镜等超分辨力显微成像系统，关键指标达到国际先进水平，为新一代数字病理分析提供技术支撑。
      </p>
      <p>
        复合内窥镜成像系统。重点突破三维环扫扇扫超声成像、高倍数荧光造影光学放大成像、激光断层扫描成像等内窥实时成像关键技术，攻克超声电子复合内窥探头、荧光显微内窥探头等核心部件的设计制造瓶颈，研发超声、共聚焦、光相干层析等高端内镜成像系统，达到国际先进或领先水平，实现消化、呼吸、泌尿等医学领域的应用，促进肺癌、胃癌等重大肿瘤疾病的早期诊断治疗。
      </p>
      <p>2. 体外诊断类</p>
      <p>
        智能化现场快速检测系统。重点开发集成式干化学分析仪、自动化免疫快速检测仪、掌上测序仪、便携式核酸检测仪及配套检测试剂与质控品；研制无创采集样本的高灵敏度现场快速检测技术以及配套试剂。开展无创血糖检测仪、可穿戴式体外检测技术和设备的研究。
      </p>
      <p>
        新型分子诊断系统。重点开发现场快速提取/检测核酸一体化平台、新型基因测序仪、随检全自动核酸检测系统、定量数字PCR等系统。
      </p>
      <p>
        医用多模态流式细胞仪。研制多色荧光、流式微球定量流式细胞仪、胞内成分检测流式细胞仪、流式分子表型分析与免疫表型分析仪等多模流式细胞仪及配套试剂。
      </p>
      <p>
        新型医用质谱仪。研制基于基质辅助激光解吸附等软电离方式的飞行时间、四极杆或串联高精度质谱仪。研制常用的同位素内部参考品，并建立常用的质谱数据分析库。
      </p>
      <p>
        全自动微生物分析系统。重点开发非培养微生物自动化分析系统、自动化血培养系统、微生物自动鉴定与药敏分析系统、微生物临床样本自动预处理系统等微生物全自动分析装备。
      </p>
      <p>
        快速病理诊断系统。重点开发智能化的快速病理诊断系统、基于相衬能谱的病理显微CT。重点突破病理切片常规染色、免疫组化和原位FISH的自动化技术、病理片的智能图像分析技术、纳米级别快速组织学X-射线立体成像技术。
      </p>
      <p>3. 先进治疗类</p>
      <p>
        智能感知交互手术机器人。重点开发具国际先进水平的高精度手术规划、导航、定位的智能医疗机器人系统，包括腹部微创治疗腔镜手术，骨科、心脑血管、神经、口腔、眼科等智能手术机器人系统。突破快速图像配准、高精度定位、智能人机交互、多自由度精准控制等关键技术。
      </p>
      <p>
        复合引导放射治疗系统。重点开发用于不同特性肿瘤共存情况下高精度放射治疗系统，重点突破多模式高清晰导航，多靶区肿瘤一次摆位同机治疗、高精度定位与剂量引导，小型化/高稳定性放射源、自适应TPS等技术。
      </p>
      <p>
        植入式有源治疗装置。重点开发具有自动化起搏功能、低功耗的植入式心脏起搏器，高性能、低成本的国产人工耳蜗，植入式脊髓刺激器、人工视网膜等产品。
      </p>
      <p>
        血液净化与透析机及耗材。重点开发高质量、低成本的血液透析机、血液透析滤过机、透析器/滤器/灌流器。重点解决国产血液透析设备及透析器/灌流器稳定性、批量生产工艺性和核心部件问题。
      </p>
      <p>4. 生物医用材料类</p>
      <p>
        骨科修复与植入材料及器械。重点开发具有国际领先水平的可承载骨诱导修复材料，可吸收骨固定产品，高耐磨、长耐久新型人工髋、人工膝及人工椎间盘等产品。
      </p>
      <p>
        口腔种植修复材料与系统。重点开发高生物相容性的口腔种植修复体、数字化精确牙体预备装置、口腔三维影像手术导航系统。重点突破全瓷义齿氧化锆瓷块、纳米晶粉体制备、三维影像引导种植等关键技术。
      </p>
      <p>
        新型心脑血管植介入器械。重点开发新一代全降解血管支架、小口径人造血管、新型人工心脏瓣膜系统、智能消融设备和导管等产品。重点突破血管支架可控降解及药物缓释、小口径人造血管抗凝血与抗栓塞、心脏瓣膜缓钙化、抗凝血、抗增生等技术。
      </p>
      <p>
        中枢神经修复与再生材料。重点开发具有国际领先水平可促进中枢神经再生的脊髓、脑神经修复的中枢神经修复材料和产品，研发中枢神经再生的植入导管等器械及辅助手术系统。
      </p>
      <p>5. 健康器械类</p>
      <p>
        健康感知产品。重点开发智能人体生理信息感知产品，实时人体行为监测，健康状态检测、监测的健康感知产品。
      </p>
      <p>
        康复护理产品。重点开发智能康复机器人、智能助行系统、多模态康复轮椅、外骨骼机器人系统等产品。重点突破人体运动意图识别、人机交互、外骨骼柔性控制、不同适应症康复运动模式优化等关键技术。
      </p>
      <p>
        中医医疗器械。重点开发脉诊、舌诊以及针刺、灸疗、中医康复等中医设备。重点突破脉搏信号获取与分析、人体穴位辅助定位、中医智能健康辨识等技术。
      </p>
      <p>（三）注重应用需求导向，强化示范普及推广</p>
      <p>
        加大创新产品推广，继续推动实施创新医疗器械产品应用示范工程（“十百千万工程”），进一步加大创新医疗器械产品在不同层次的医疗机构开展试点示范应用的推广力度，鼓励医研企合作建设创新医疗器械示范应用基地、培训中心，研究制定创新医疗器械产品目录，形成“技术创新-产品开发-临床评价-示范应用-辐射推广”的良性循环。
      </p>
      <p>专栏4：示范推广重点发展方向</p>
       <p>
        1.解决方案集成。一是围绕早期诊断、精确诊断、微创治疗、精准治疗、专科诊疗、重症急救、远程服务、决策支持等临床需求，系统开展新型诊疗技术解决方案集成研究，加强设备配置标准、临床应用规范、诊疗路径、培训工具等研究，促进协同创新，加快国产创新产品的临床应用；建立临床技术培训基地，为新技术的完善、传播、推广提供平台。二是围绕智慧医疗、移动医疗、远程医疗、分级诊疗等临床需求，加快推进医疗器械服务与云计算、大数据等新技术的结合，重点推进医学影像云、放疗计划系统云、手术规划云、第三方医学检验、远程诊断、移动服务、智能随访、临床决策支持、数字化医院等临床服务产品的规范化研究，开发疾病的智能预测、预警、预后系统及面向心血管病、糖尿病、癌症等慢病的管理信息系统，促进数字诊疗装备新型服务模式发展。
      </p>
      <p>
        2.示范推广应用。“十百千万工程”试点示范的基础上，加快构建体系化、机制化的创新医疗产品示范推广体系，通过区域综合示范和三甲医院示范，推动建立覆盖三甲医院和基层医疗机构的跨地区示范网，促进国产医疗器械更为有效地为我国医疗卫生事业服务。一是在全国不同区域范围内建立国产创新产品的临床应用示范中心，系统开展国产创新产品的临床评价和示范应用研究，提高临床性能和用户认可度，打造一批国产创新产品优秀品牌。二是全面开展创新诊疗装备区域应用示范，遴选一批基础较好的地区，开展区域示范应用，结合区域常见多发病分级分层诊疗体系建设，重点推进国产诊疗装备在基层的普及化推广与应用，形成规模化示范效应，改善我国医疗服务体系的公平性、可及性、同质性。
      </p>
      <p>（四）优化平台基地布局，促进创新能力提升</p>
      <p>
        统筹加强平台基地建设，深化体制、机制和管理创新，突出学科交叉融合，突出临床需求引领，突出医研企结合的创新团队建设，布局一批重大研究平台，系统完善国家医疗器械创新体系，着力提升我国医疗器械产业的自主创新和原始创新能力。
      </p>
      <p>专栏5：平台建设重点发展方向</p>
      <p>
        1.技术创新中心。瞄准世界科技前沿和顶尖水平，吸引集聚全球顶尖科研机构、领军人才和一流创新团队，布局建设世界一流医疗器械重大科技基础设施群和创新集群，打造国际领先的医疗器械领域技术创新中心。
      </p>
      <p>
        2.共性技术平台。加强医疗器械共性技术平台建设，重点建设医学影像、数字诊疗、物理治疗、体外诊断、生物医用材料、个性化设计和制造、电磁兼容等15-20个技术研发平台。
      </p>
      <p>
        3.临床评价中心。优选具备一定规模、具有较强的科研能力和管理水平的三甲医疗机构，建立一批国产创新产品的临床评价中心，完善医疗器械创新链条，促进国产创新品牌培育。
      </p>
      <p>（五）集聚创新创业要素，助力产业集群发展</p>
      <p>
        集聚创新要素，完善产业链条，促进产业协同，加强医疗器械创新集聚区和产业化基地建设，重点推进8-10个国家级医疗器械科技产业基地建设。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabInnovationPlan'
}
</script>

<style lang="scss" scoped>
.content{
  font-size: 18px;
  color: #6a6a6a;
  p{
    font-size: 18px;
    line-height: 36px;
    text-indent:40px;
  }
}
</style>
